// 고객 구분
export const CUSTOMER_TYPES = [
  { value: 'REHEARSAL_AND_MAIN', label: '리허설+본식' },
  { value: 'REHEARSAL', label: '리허설' },
  { value: 'MAIN', label: '본식' },
];

export const CUSTOMER_TYPE_COLORS: Record<string, string> = {
  REHEARSAL_AND_MAIN: 'bg-purple-100 text-purple-700',
  REHEARSAL: 'bg-blue-100 text-blue-700',
  MAIN: 'bg-orange-100 text-orange-700',
};

// 고객 상태
export const CUSTOMER_STATUSES = [
  '발주', '리허설대기', '리허설완료', '본식대기', '본식완료', '정산완료', '취소'
] as const;

export const CUSTOMER_STATUS_COLORS: Record<string, string> = {
  '발주': 'bg-blue-100 text-blue-700',
  '리허설대기': 'bg-cyan-100 text-cyan-700',
  '리허설완료': 'bg-teal-100 text-teal-700',
  '본식대기': 'bg-orange-100 text-orange-700',
  '본식완료': 'bg-green-100 text-green-700',
  '정산완료': 'bg-gray-800 text-white',
  '취소': 'bg-red-100 text-red-700',
};

// 계약 유형
export const CONTRACT_TYPES = [
  { value: 'REHEARSAL_AND_MAIN', label: '리허설+본식' },
  { value: 'REHEARSAL', label: '리허설' },
  { value: 'MAIN', label: '본식' },
];

export const CONTRACT_TYPE_COLORS: Record<string, string> = {
  REHEARSAL_AND_MAIN: 'bg-purple-100 text-purple-700',
  REHEARSAL: 'bg-blue-100 text-blue-700',
  MAIN: 'bg-orange-100 text-orange-700',
};

// 계약 상태
export const CONTRACT_STATUSES = [
  { value: 'ACTIVE', label: '진행중' },
  { value: 'COMPLETED', label: '완료' },
  { value: 'CANCELLED', label: '취소' },
];

export const CONTRACT_STATUS_COLORS: Record<string, string> = {
  ACTIVE: 'bg-green-100 text-green-700',
  COMPLETED: 'bg-blue-100 text-blue-700',
  CANCELLED: 'bg-red-100 text-red-700',
};

// 서비스 품목 카테고리
export const ITEM_CATEGORIES = [
  { value: 'REHEARSAL_MAKEUP', label: '리허설 메이크업' },
  { value: 'REHEARSAL_HAIR', label: '리허설 헤어' },
  { value: 'MAIN_MAKEUP', label: '본식 메이크업' },
  { value: 'MAIN_HAIR', label: '본식 헤어' },
  { value: 'HONJU_MAKEUP', label: '혼주 메이크업' },
  { value: 'HONJU_HAIR', label: '혼주 헤어' },
  { value: 'TOUCH_UP', label: '터치업' },
  { value: 'ETC', label: '기타' },
];

// 일정 카테고리
export const SCHEDULE_CATEGORIES = [
  { value: 'TASK', label: '업무', color: 'bg-cyan-500' },
  { value: 'REHEARSAL', label: '리허설', color: 'bg-blue-500' },
  { value: 'MAIN_CEREMONY', label: '본식', color: 'bg-orange-500' },
  { value: 'CONSULTATION', label: '상담', color: 'bg-green-500' },
  { value: 'PAYMENT', label: '결제', color: 'bg-lime-500' },
];

export const SCHEDULE_CATEGORY_COLORS: Record<string, string> = {
  TASK: 'bg-cyan-100 text-cyan-700 border-cyan-300',
  REHEARSAL: 'bg-blue-100 text-blue-700 border-blue-300',
  MAIN_CEREMONY: 'bg-orange-100 text-orange-700 border-orange-300',
  CONSULTATION: 'bg-green-100 text-green-700 border-green-300',
  PAYMENT: 'bg-lime-100 text-lime-700 border-lime-300',
};

// 일정 섹션
export const SCHEDULE_SECTIONS = [
  { value: 'TASK', label: '업무일정' },
  { value: 'SHOP', label: '샵 일정 (내방 고객)' },
  { value: 'ONSITE', label: '출장 일정 (외부 방문)' },
];

// 일정 상태
export const SCHEDULE_STATUSES = ['예정', '도착', '진행중', '완료', '지연', '노쇼', '취소'] as const;

export const SCHEDULE_STATUS_COLORS: Record<string, string> = {
  '예정': 'bg-blue-100 text-blue-700',
  '도착': 'bg-teal-100 text-teal-700',
  '진행중': 'bg-indigo-100 text-indigo-700',
  '완료': 'bg-green-100 text-green-700',
  '지연': 'bg-red-100 text-red-700',
  '노쇼': 'bg-gray-800 text-white',
  '취소': 'bg-red-100 text-red-700',
};

// 결제 유형
export const PAYMENT_TYPES = [
  { value: 'FULL', label: '일시납부' },
  { value: 'CONTRACT', label: '계약금' },
  { value: 'INTERMEDIATE', label: '중도금' },
  { value: 'BALANCE', label: '잔금' },
  { value: 'ETC', label: '기타' },
];

export const PAYMENT_TYPE_COLORS: Record<string, string> = {
  FULL: 'bg-purple-100 text-purple-700',
  CONTRACT: 'bg-blue-100 text-blue-700',
  INTERMEDIATE: 'bg-orange-100 text-orange-700',
  BALANCE: 'bg-green-100 text-green-700',
  ETC: 'bg-gray-100 text-gray-700',
};

// 결제 상태
export const PAYMENT_STATUSES = [
  { value: 'COMPLETED', label: '결제완료' },
  { value: 'SCHEDULED', label: '결제예정' },
  { value: 'REFUNDED', label: '환불됨' },
  { value: 'CANCELLED', label: '취소됨' },
];

export const PAYMENT_STATUS_COLORS: Record<string, string> = {
  COMPLETED: 'bg-green-100 text-green-700',
  SCHEDULED: 'bg-blue-100 text-blue-700',
  REFUNDED: 'bg-orange-100 text-orange-700',
  CANCELLED: 'bg-red-100 text-red-700',
};

// 결제 수단
export const PAYMENT_METHODS = [
  { value: 'CARD', label: '카드' },
  { value: 'TRANSFER', label: '계좌이체' },
  { value: 'CASH', label: '현금' },
];

// 정산 상태
export const SETTLEMENT_STATUSES = [
  { value: '', label: '전체' },
  { value: 'PENDING', label: '미정산' },
  { value: 'SETTLED', label: '정산' },
];

export const SETTLEMENT_STATUS_COLORS: Record<string, string> = {
  PENDING: 'bg-red-100 text-red-700',
  SETTLED: 'bg-green-100 text-green-700',
};

// 유입경로
export const REFERRAL_SOURCES = [
  { value: '웨딩플래너', label: '웨딩플래너' },
  { value: '인스타그램', label: '인스타그램' },
  { value: '블로그/카페', label: '블로그/카페' },
  { value: '지인소개', label: '지인소개' },
  { value: '네이버검색', label: '네이버검색' },
  { value: '유튜브', label: '유튜브' },
  { value: '방문(워크인)', label: '방문(워크인)' },
  { value: '기타', label: '기타' },
];

export const REFERRAL_SOURCE_DETAILS: Record<string, { value: string; label: string }[]> = {
  '웨딩플래너': [
    { value: '더채플', label: '더채플' },
    { value: '루나웨딩', label: '루나웨딩' },
    { value: '아이웨딩', label: '아이웨딩' },
    { value: '듀오웨드', label: '듀오웨드' },
    { value: '기타플래너', label: '기타 플래너' },
  ],
  '인스타그램': [
    { value: '피드광고', label: '피드 광고' },
    { value: '릴스', label: '릴스' },
    { value: '해시태그검색', label: '해시태그 검색' },
    { value: 'DM문의', label: 'DM 문의' },
  ],
  '블로그/카페': [
    { value: '네이버블로그', label: '네이버 블로그' },
    { value: '웨딩카페', label: '웨딩 카페' },
    { value: '후기게시판', label: '후기 게시판' },
  ],
  '지인소개': [
    { value: '기존고객', label: '기존 고객 소개' },
    { value: '지인', label: '지인 소개' },
  ],
};

// 조회기간 기준
export const DATE_CRITERIA = [
  { value: 'orderDt', label: '발주일' },
  { value: 'rehearsalDt', label: '리허설일' },
  { value: 'weddingDt', label: '본식일' },
];

// 정산 조회기간 기준
export const SETTLEMENT_DATE_CRITERIA = [
  { value: 'orderDt', label: '발주일' },
  { value: 'rehearsalDt', label: '리허설일' },
  { value: 'weddingDt', label: '본식일' },
  { value: 'settledDt', label: '정산일' },
];

// 이름조회 기준
export const SEARCH_CRITERIA = [
  { value: 'all', label: '전체' },
  { value: 'groom', label: '신랑' },
  { value: 'bride', label: '신부' },
  { value: 'partnerStaff', label: '업체담당자' },
  { value: 'phone', label: '전화번호' },
];

// 샵/출장 구분
export const SCHEDULE_TYPE_OPTIONS = [
  { value: 'SHOP', label: '샵 (내방)' },
  { value: 'ONSITE', label: '출장 (외부)' },
];
